<div class="widgets">
  <div class="title" (click)="voirDetails()">
    <span class="title_left">
      <i class="fa fa-tachometer" aria-hidden="true"></i>
      <span>
        {{ 'HOME.HEURES_SAISIES.TITLE' | translate }}
        @if (state === allStates.SUCCESS) {
          <span>{{ ' ' + this.timeTitleDisplay }}</span>
        }
      </span>
    </span>
    <a class="title_right">{{ 'HOME.HEURES_SAISIES.SEE_DETAILS' | translate }}</a>
  </div>
  <div class="content">
    @if (state === allStates.LOADING) {
      <div class="loading-content center">
        <ion-icon name="sync" class="infinite-rotate"></ion-icon>
        <span>{{ 'GLOBAL.LOADING' | translate }}</span>
      </div>
    } @else {
      @if (state === allStates.SUCCESS) {
        <gauge-bar class="gauge" [gaugeData]="gaugeData"></gauge-bar>
      } @else {
        <div class="loading-content center">
          <span>{{ 'HOME.HEURES_SAISIES.ERROR' | translate }}</span>
        </div>
      }
    }
  </div>
</div>
